import { Button } from '@grupoboticario/flora-react';
import styled from 'styled-components';
import Text from 'styles/typography';
import { STATUS_OBJ } from 'utils/statusEnum';
import { ClaimStatus } from './types';

type ContainerStatus = ClaimStatus | 'Clean';
type ClaimCardProps = {
  status?: ContainerStatus;
};
export const Container = styled.div<ClaimCardProps>`
  min-width: 170px;
  max-width: 280px;
  height: 196px;
  display: flex;
  flex-direction: column;
  padding: 12px 10px;
  opacity: ${({ status }) => status === 'Clean' && '0.4'};

  background-color: ${({ theme }) => theme.colors.shape};

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.12);
  border-radius: 4px;

  p {
    color: ${({ theme, status }) =>
      status === STATUS_OBJ.Draft && theme.colors.main};
  }

  border: 2px solid
    ${({ theme, status }) =>
      status === STATUS_OBJ.Draft ? theme.colors.main : theme.colors.shape};

  [class*='styles__Header'],
  [class*='styles__MainContent'],
  [class*='styles__TagsHeader'] {
    border-bottom: 0.4px solid
      ${({ theme, status }) =>
        status === STATUS_OBJ.Draft ? theme.colors.main : theme.colors.line};
  }
`;
type hasDaysAndStatus = {
  hasTwoChildren: any;
};

export const TagsHeader = styled.div<hasDaysAndStatus>`
  display: flex;
  justify-content: ${({ hasTwoChildren }) =>
    hasTwoChildren ? 'space-between' : 'flex-end'};
`;

export const MainTags = styled.div<hasDaysAndStatus>`
  display: flex;
  width: 100%;
  align-items: center;
  font-weight: 500;
  font-size: 14px;

  padding-bottom: 7px;
  justify-content: ${({ hasTwoChildren }) =>
    hasTwoChildren ? 'space-between' : 'flex-end'};
`;

export const Header = styled.div`
  display: flex;
  width: 100%;

  align-items: center;
  justify-content: space-between;

  font-weight: 500;
  font-size: 14px;

  padding-bottom: 7px;
`;

export const MainContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  margin-top: 5px;
  padding-bottom: 5px;

  #claim-type {
    width: 60%;
  }
`;

export const Title = styled(Text)`
  font-weight: 500;
  line-height: initial;
  font-size: 14px;
  padding-top: 8px;
`;

export const Label = styled(Text)`
  font-weight: 500;
  line-height: initial;
  font-size: 9px;
  color: ${({ theme }) => theme.colors.textLight};
`;

export const MainText = styled(Text)`
  font-weight: 500;
  font-size: 12px;
  line-height: inherit;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TagText = styled(Text)`
  line-height: initial;
  font-weight: 500;
  font-size: 10px;
`;

export const Footer = styled.div`
  display: flex;
  margin-top: 13px;
  align-items: center;
  justify-content: center;
`;

export const ActionButton = styled(Button)`
  & + & {
    margin-left: 6px;
  }
  height: 32px;
  padding: 8px 14px;

  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 14px;
  // box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.main};

  &.warning-ghost {
    background: ${({ theme }) => theme.colors.shape};
    color: ${({ theme }) => theme.colors.error};
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.error};

    transition: background 150ms ease, box-shadow 150ms ease, color 150ms ease;

    &:hover {
      background: ${({ theme }) => theme.colors.error};
      color: ${({ theme }) => theme.colors.shape};
    }
  }
`;

export const ModalText = styled(Text)`
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
`;
